import {Redirect} from "react-router-dom";

const IndexPage = () => {

    return <Redirect to={"/ui"} />

}

export default IndexPage;
